/* eslint-disable max-len */
import * as questionIds from "../../questions/questionIds";

export const workingConfinedSpacesQuestions = [
    {
        id: questionIds.StorageTanks,
        questionText: "Storage tanks",
    },
    {
        id: questionIds.StorageTanksFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.Silos,
        questionText: "Silos",
    },
    {
        id: questionIds.SilosFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.Sewers,
        questionText: "Sewers",
    },
    {
        id: questionIds.SewersFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.Vats,
        questionText: "Vats",
    },
    {
        id: questionIds.VatsFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.Ductwork,
        questionText: "Ductwork",
    },
    {
        id: questionIds.DuctworkFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.PoisonousGas,
        questionText: "Poisonous gas, fume or vapour",
    },
    {
        id: questionIds.PoisonousGasFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.ResiduesLeftInTanks,
        questionText: "Residues left in tanks, vessels etc",
    },
    {
        id: questionIds.ResiduesLeftInTanksFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.ReactionVessels,
        questionText: "Reaction vessels",
    },
    {
        id: questionIds.ReactionVesselsFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.EnclosedDrains,
        questionText: "Enclosed drains",
    },
    {
        id: questionIds.EnclosedDrainsFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.OpenToppedChambers,
        questionText: "Open-topped chambers",
    },
    {
        id: questionIds.OpenToppedChambersFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.CombustionChambers,
        questionText: "Combustion chambers in furnaces etc",
    },
    {
        id: questionIds.CombustionChambersFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.UnventilatedPoorlyVentilatedRooms,
        questionText: "Unventilated or poorly ventilated rooms",
    },
    {
        id: questionIds.UnventilatedPoorlyVentilatedRoomsFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.HotConditions,
        questionText: "Hot conditions",
    },
    {
        id: questionIds.HotConditionsFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.DustPresentHighConcentrations,
        questionText: "Dust present in high concentrations",
    },
    {
        id: questionIds.DustPresentHighConcentrationsFurtherDetails,
        questionText: "Please provide details",
    }
];
